import type MapProperty from '../private/IMapProperty';

/**
 * @description array of each field & how to convert between external(api) & internal representations
 */
const MAPPINGS: MapProperty[] = [
    /* Cannot use 'name' as PK, as name may be set the same across multiple translations */
    {
        localName: 'tourSupportedLanguageId',

        defaultValue: 0,
    },

    {
        localName: 'name',

        defaultValue: '',
    },
    {
        localName: 'completed',

        defaultValue: false,
    },
    {
        localName: 'mediumId',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'mediumFileName',

        defaultValue: '',
        optional: true,
    },
    {
        localName: 'removeMedium',

        defaultValue: false,
        optional: true,
    },
];

export default MAPPINGS;
